import React from 'react';
import { Building2, Star, Award, TrendingUp, Users } from 'lucide-react';
import { clients, stats } from '../data/mock';

const Clients = () => {
  return (
    <section id="clients" className="py-28 bg-gradient-to-b from-shsNavy via-shsNavy to-shsBlue relative overflow-hidden">
      {/* Premium Background Pattern */}
      <div className="absolute inset-0">
        <div className="absolute top-0 left-0 w-full h-full opacity-5" style={{
          backgroundImage: `radial-gradient(circle at 1px 1px, white 1px, transparent 0)`,
          backgroundSize: '40px 40px'
        }} />
      </div>
      
      {/* Glow Effects */}
      <div className="absolute top-0 left-1/4 w-[500px] h-[500px] bg-shsTeal/20 rounded-full blur-[150px]" />
      <div className="absolute bottom-0 right-1/4 w-[500px] h-[500px] bg-shsGold/10 rounded-full blur-[150px]" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        {/* Premium Stats Section */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8 mb-24">
          {stats.map((stat, index) => (
            <div
              key={stat.id}
              className="group relative text-center p-8 bg-white/5 backdrop-blur-sm rounded-3xl border border-white/10 hover:bg-white/10 hover:border-shsTeal/30 transition-all duration-500"
            >
              {/* Hover Glow */}
              <div className="absolute inset-0 bg-gradient-to-br from-shsTeal/10 to-shsGold/10 opacity-0 group-hover:opacity-100 rounded-3xl transition-opacity duration-500" />
              
              <div className="relative z-10">
                <p className="text-5xl lg:text-6xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-shsGold via-amber-400 to-shsGold mb-3">
                  {stat.value}
                </p>
                <p className="text-white/70 text-sm lg:text-base font-medium">
                  {stat.label}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Clients Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-5 py-2.5 bg-shsTeal/20 rounded-full text-sm font-semibold mb-6 border border-shsTeal/30">
            <Building2 className="w-4 h-4 text-shsTeal" />
            <span className="text-shsTeal">Our Partners</span>
          </div>
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
            Trusted by
            <span className="block text-transparent bg-clip-text bg-gradient-to-r from-shsGold via-amber-400 to-shsGold">
              Industry Leaders
            </span>
          </h2>
          <p className="text-white/60 text-lg max-w-2xl mx-auto">
            We're proud to partner with some of the most prestigious names in hospitality,
            from international chains to boutique properties.
          </p>
        </div>

        {/* Clients Grid - Premium Cards */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 lg:gap-6">
          {clients.map((client) => (
            <div
              key={client.id}
              className="group relative bg-white/5 backdrop-blur-sm rounded-2xl p-6 lg:p-8 flex flex-col items-center justify-center min-h-[140px] border border-white/10 hover:bg-white hover:border-transparent transition-all duration-500 cursor-pointer"
            >
              {/* Hover Effect */}
              <div className="absolute inset-0 bg-gradient-to-br from-shsTeal to-shsBlue opacity-0 group-hover:opacity-100 rounded-2xl transition-all duration-500" />
              
              <div className="relative z-10 text-center">
                <Building2 className="w-10 h-10 text-white/40 group-hover:text-white mb-3 transition-all duration-300 mx-auto group-hover:scale-110" />
                <p className="text-white/70 group-hover:text-white font-semibold text-sm transition-colors">
                  {client.name}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Premium Trust Badge */}
        <div className="mt-20 text-center">
          <div className="inline-flex items-center gap-4 px-8 py-5 bg-gradient-to-r from-shsGold/20 via-shsGold/10 to-shsGold/20 rounded-full border border-shsGold/30 backdrop-blur-sm">
            <div className="flex">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="w-5 h-5 text-shsGold fill-shsGold" />
              ))}
            </div>
            <div className="w-px h-6 bg-shsGold/30" />
            <p className="text-shsGold font-semibold">
              Join 10+ Hotels That Trust Supreme Hospitality Solutions
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Clients;
